import { render, staticRenderFns } from "./W10V1.vue?vue&type=template&id=3aa18c10&scoped=true&"
import script from "./W10V1.vue?vue&type=script&lang=js&"
export * from "./W10V1.vue?vue&type=script&lang=js&"
import style0 from "./W10V1.vue?vue&type=style&index=0&id=3aa18c10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa18c10",
  null
  
)

export default component.exports